'use client';

import { useMediaQuery } from 'usehooks-ts';

import { breakpoints } from '@shaojiang/theme/preset/breakpoints';

const below = (bp: keyof typeof breakpoints) =>
  `(max-width: ${parseFloat(breakpoints[bp]) - 0.02}px)`;

/** Viewport flags matching Panda's `xlDown` / `mdDown` conditions. */
export default function useBreakpoints() {
  const xlDown = useMediaQuery(below('xl'), { initializeWithValue: false });
  const mdDown = useMediaQuery(below('md'), { initializeWithValue: false });

  return { xlDown, mdDown };
}
